import { render, staticRenderFns } from "./DictionariesShowNestedResourcesButton.vue?vue&type=template&id=611c3185&"
import script from "./DictionariesShowNestedResourcesButton.vue?vue&type=script&lang=js&"
export * from "./DictionariesShowNestedResourcesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports